var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle__container"},[_c('div',{staticClass:"circle-half",style:({ width: `${_vm.circleSize / 2}px`, height: `${_vm.circleSize}px` })},[_c('div',{class:`circle background-${_vm.leftColor}`,style:({
        borderRadius: `${_vm.leftSize / 2}px`,
        width: `${_vm.leftSize}px`,
        height: `${_vm.leftSize}px`,
        right: `-${_vm.leftSize / 2}px`,
        top: `${_vm.circleSize / 2 - _vm.leftSize / 2}px`,
      })}),(!_vm.hideLeftAmount)?_c('div',{staticClass:"circle__label"},[_c('span',{class:{ 'f-ui-1': _vm.circleSize > 100, 'f-ui-2': _vm.circleSize <= 100 }},[_vm._v(_vm._s(_vm.left)+" "+_vm._s(_vm.units))])]):_vm._e()]),_c('div',{staticClass:"circle-half",style:({ width: `${_vm.circleSize / 2}px`, height: `${_vm.circleSize}px` })},[_c('div',{class:`circle background-${_vm.rightColor}`,style:({
        borderRadius: `${_vm.rightSize / 2}px`,
        width: `${_vm.rightSize}px`,
        height: `${_vm.rightSize}px`,
        left: `-${_vm.rightSize / 2}px`,
        top: `${_vm.circleSize / 2 - _vm.rightSize / 2}px`,
      })}),_c('div',{staticClass:"circle__label"},[_c('span',{class:{ 'f-ui-1': _vm.circleSize > 100, 'f-ui-2': _vm.circleSize <= 100 }},[_vm._v(_vm._s(_vm.right))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }